module.exports = __webpack_public_path__ + "assets/img/2@3x.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2@3x.png
// module id = 1914
// module chunks = 0